import { styled } from '@linaria/react';

import { BookmakersLabel } from './components/OddsGridTable/OddsGridHeader.style';
import { OddsCellBtn, OddsCellDesktop, OddsCellMobile } from './components';

export const MarketExpanderWrapper = styled.section`
  margin: 5px 0 0 0;

  #subevent-ads-wrapper:first-of-type & {
    margin-top: 0;
  }

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      margin: 5px auto 0;
    }
  }
`;

export const GridBackground = styled.section`
  margin: 0 0 10px;
  background: var(--ogm-grid-main-bg-color);
  border: 1px solid var(--ogm-grid-main-border-color);
  border-top-width: 0;
  border-radius: 0 0 5px 5px;

  transition: opacity 250ms ease;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: grid;
      margin: 15px auto;
      border-width: 0;
      width: 100%;
      border: 1px solid var(--ogm-grid-main-border-color);
    }
  }

  @media (max-width: 767px) {
    & > * {
      grid-column: 2;
    }
  }

  // must be same as above
  [data-testid='odds-grid'][data-enforce-mobile] & > * {
    grid-column: 2;
  }
`;

export const GridContentWrapper = styled.div`
  padding: 0;
  overflow: hidden;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      margin: 0 25px;
      overflow: hidden;
    }
  }

  @media (min-width: 1256px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      padding: 0;
      margin: 0 45px 20px 45px;
    }
  }
`;

export const UnsupportedMessageWrapper = styled.div`
  padding: 0 15px;
  margin: 16px 0;
`;

export const UnsupportedMessageContent = styled.div`
  height: 100%;
  background: #edf3fa;
  border: 1px solid #77a6d7;
  border-radius: 5px;
  padding: 8px;
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #0059b5;
`;

export const ShowMoreContainer = styled.div`
  color: var(--oc-primary-blue);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 15px;
  width: 100%;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  border-top: none;
`;

export const ShowMoreText = styled.button`
  cursor: pointer;
`;

export const DesktopOnly = styled.div`
  display: none;
  pointer-events: none;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: block;
      pointer-events: auto;
    }
  }
`;

export const MobileOnly = styled.div`
  display: block;
  pointer-events: auto;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: none;
      pointer-events: none;
    }
  }

  [data-testid='odds-grid'][data-enforce-mobile] & {
    display: block;
    pointer-events: auto;
  }
`;

export const MobileOnlyGridWrapper = styled.div``;

export const MarketWrapper = styled.article`
  width: 100%;

  & > * {
    font-family: var(--ogm-font-family-2);
  }

  @media (min-width: 1024px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      margin: 0;
    }
  }

  &.not-supported {
    ${GridBackground} {
      border-color: var(--ogm-border-color-1);
    }

    ${OddsCellDesktop}${OddsCellBtn} {
      font-weight: 700;
      color: var(--ogm-disabled-grey);
      pointer-events: none;
      border-radius: 16px;
      border-color: var(--ogm-disabled-grey);
    }

    ${OddsCellMobile} {
      background-color: transparent;
      color: var(--ogm-disabled-grey);
      border: 1px solid var(--ogm-disabled-grey);
      border-radius: 16px;
      font-size: 15px;
      width: 65px;
    }

    ${BookmakersLabel} {
      font-weight: 500;
    }
  }
`;
